/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportOrderType = {
    LMT: 'LMT',
    MOC: 'MOC',
    MKT: 'MKT'
} as const;
export type ReportOrderType = typeof ReportOrderType[keyof typeof ReportOrderType];


export function instanceOfReportOrderType(value: any): boolean {
    for (const key in ReportOrderType) {
        if (Object.prototype.hasOwnProperty.call(ReportOrderType, key)) {
            if (ReportOrderType[key as keyof typeof ReportOrderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportOrderTypeFromJSON(json: any): ReportOrderType {
    return ReportOrderTypeFromJSONTyped(json, false);
}

export function ReportOrderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportOrderType {
    return json as ReportOrderType;
}

export function ReportOrderTypeToJSON(value?: ReportOrderType | null): any {
    return value as any;
}

export function ReportOrderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportOrderType {
    return value as ReportOrderType;
}

